
declare var dataLayer: any;
import { Vue, Component, Prop } from "vue-property-decorator";
import api from "../../helpers/api.ts";

@Component({
  components: {
    Questions: () => import("@/components/postulation/Questions.vue"),
    PhoneInput: () => import("@/components/Jobs/Profile/PhoneInput.vue"),
  },
})
export default class PostulationQuick extends Vue {
  offerId: number = 0;
  offer: any = {};
  form = {
    name: "",
    l_name: "",
    email: "",
    // se agrega email2 para comparar
    email2: "",
    password: "",
    r_password: "",
    phone: "",
    type_document: "",
    number_document: "",
    area: true,
    registry: true,
  };
  Preguntas: any = [];
  step_quick = 1;
  hash = Math.random() * 100000;
  errorMsg = "";
  nameInvalid = false;
  l_nameInvalid = false;
  type_documentInvalid = false;
  number_documentInvalid = false;
  typeDoc = [];
  phone = {
    phonepais: "",
    phonearea: null,
    phone: null,
  };
  errorPhone = {
    flag: true,
    type: "",
  };

  goToOfertas() {
    (window as any).location = "/ofertas";
  }

  async showModal() {
    const _this: any = this;
    _this.step_quick = 1;
    _this.form.name = "";
    _this.form.email = "";
    //se agrega email2 para comparar limpio al abrir formulario
    _this.form.email2 = "";
    _this.form.phone = "";
    _this.form.type_document = "";
    _this.form.number_document = "";
    _this.form.area = true;
    _this.form.registry = true;
    _this.popEmail();
    if (_this.$refs.input_mask_ref) _this.$refs.input_mask_ref.elValue = "";
    this.typeDoc = (
      await (this as any).$root._get("nucleus_types/TIPOS_DOC")
    ).data.map((item: any) => {
      return { ...item, label: item.description };
    });
    _this.offer = (
      await _this.$root._get(`offer/one/${_this.offerId}`)
    ).data[0];
    if (_this.offer.ask_income) {
      _this.Preguntas = [
        ..._this.offer.nucleus_offer.Preguntas,
        {
          Opciones: [],
          ID: 9999,
          d_pregunta: "Cuál es su sueldo pretendido?",
        },
      ];
    } else {
      _this.Preguntas = _this.offer.nucleus_offer.Preguntas;
    }
    localStorage.setItem("bayton-quick-offer", _this.offerId);
    // (this as any).$root.quick_offer = _this.offerId;
    _this.$refs["postulate-quick-modal"].show();
    dataLayer.push({
      event: "VirtualPageview",
      virtualPageURL: "/postulacion-rapida",
      virtualPageTitle: "Postulación Rápida",
    });
  }

  hideModal() {
    (this as any).$refs["postulate-quick-modal"].hide();
  }

  created() {
    window.addEventListener("resize", (this as any).$root.handleResize);
    (this as any).$root.handleResize();
    (this as any).$root.$on("bv::modal::hide", (bvEvent: any, modalId: any) => {
      if ((this as any).step_quick === 3) {
        (location as any).reload();
      }
    });
  }

  destroyed() {
    window.removeEventListener("resize", (this as any).$root.handleResize);
  }

  popEmail() {
    let i = (this as any).$root.error_bt.indexOf("email");
    if (i >= 0) {
      (this as any).$root.error_bt.splice(i, 1);
    }
  }

//se agrega popEmail2() para email2
 popEmail2() {
    let i = (this as any).$root.error_bt.indexOf("email2");
    if (i >= 0) {
      (this as any).$root.error_bt.splice(i, 1);
    }
  }

  validateName() {
    return true;
  }

  async showQuestions() {
    console.log("paso");
    const _this: any = this;
    let elements = [
      "name",
      "l_name",
      "email",
      "type_document",
      "number_document",
    ];
    if (_this.Preguntas.length === 0) {
      console.log("paso 3");
      _this.sendPostulation();
    } else {
      await _this.$root.validateBeforeSubmit(elements, _this.form);
      console.log(_this.$root.error_bt);
      if (_this.$root.error_bt.length === 0 && this.validateName()) {
        _this.step_quick = 2;
      }
    }
  }

  async sendPostulation() {
    const _this: any = this;
    try {
      let elements = [
        "name",
        "l_name",
        "email",
        "type_document",
        "number_document",
      ];
      let phone = `${(this as any).$root.getPhoneCountryCode(
        (this as any).phone.phonepais
      )}${(this as any).$root.getPhoneAreaCode(
        (this as any).phone.phonearea
      )}${(this as any).$root.getPhoneNumber((this as any).phone.phone)}`;
      await _this.$root.validateBeforeSubmit(elements, _this.form);

      //comparo los emails ingresados de no coincidir disparo el error
      if (_this.form.email !== _this.form.email2) {
        throw { customError: "Los emails no coinciden" };
      }

      if (_this.form.password !== _this.form.r_password) {
        throw { customError: "Las contraseñas no coinciden" };
      }
      let phone_true = true;
      this.errorPhone = (this as any).$root.validateNumber(phone);
      if (phone !== "" && phone !== null && !(this as any).errorPhone.flag) {
        phone_true = false;
      }

      if (
        _this.$root.error_bt.length === 0 &&
        this.validateName() &&
        phone_true
      ) {
        const response = await _this.$root._post("user", {
          dni_type: (this as any).form.type_document.id,
          dni: (this as any).form.number_document,
          first_name: _this.form.name,
          last_name: _this.form.l_name,
          username: _this.form.email,
          email: _this.form.email,
          phone: phone,
          password: _this.form.password,
          nucleus_user: {
            c_nro_doc: (this as any).form.number_document,
            oi_tipo_documento:
              ((this as any).form.type_document &&
                (this as any).form.type_document.external_id) ||
              0,
            d_apellido: _this.form.l_name,
            d_email: _this.form.email,
            te_celular: _this.phone.phone,
            c_area_cel: _this.phone.phonearea,
            c_pais_cel: _this.phone.phonepais,
            d_nombres: `${_this.form.name} ${_this.form.l_name}`,
            estudiosCV: [],
          },
          role: 2,
        });

        const response3 = await _this.$root._post("user/login", {
          username: _this.form.email,
          password: _this.form.password,
        });
        _this.$store.commit("setToken", response3.token);

        const response4: any = await _this.$root._post("userprofessional", {
          profession: null,
          desired_place_lat: null,
          desired_place_lng: null,
          lowest_expected_salary: null,
          highest_expected_salary: null,
          wants_job_offers: false,
          is_part_time: false,
          is_full_time: false,
          is_remote: false,
          is_temporal: false,
          areaId: null,
          locationId: null,
        });

        const response5 = await _this.$root._put("user/" + response.user.id, {
          usersProfessionalId: response4.id,
        });

        await _this.$root.reloadUser();

        let n_remuneracion = 0;
        if (_this.offer.ask_income)
          n_remuneracion = _this.Preguntas.pop().answer;

        const resp = await _this.$root._post(`useroffer`, {
          status: 0,
          offerId: _this.offer.id,
          postulate: 1,
          n_remuneracion,
          favorite: _this.offer.favorite ? this.offer.favorite : 0,
          answers: this.Preguntas,
        });

        dataLayer.push({
          event: "VirtualPageview",
          virtualPageURL: "/postulacion-rapida-exitosa",
          virtualPageTitle: "Postulación Rápida Exitosa",
        });

        _this.step_quick = 3;
        _this.$refs.loader_ref.style.display = "none";
      } else {
        throw _this.$root.error_bt;
      }
    } catch (e) {
      _this.$refs.errorMsgRef.style.opacity = 1;
      _this.errorMsg =
        e && e.message && e.message === "Email already in use"
          ? "Ya existe un usuario con ese email"
          : e && e.customError
          ? e.customError
          : "No se pudo completar la postulación";
      setTimeout(() => {
        _this.$refs.errorMsgRef.style.opacity = 0;
        _this.errorMsg = "";
      }, 5000);
    }
  }
}
